import { IInputProps } from "@interfaces";
import { useController } from "react-hook-form";
import { InputTextarea, InputTextareaProps } from "primereact/inputtextarea";

import { Field } from "../../field";

//! ANTES DE MODIFICAR ESTE COMPONENTE CONSULTE CON SUS DESARROLLADORES.
//! ANTES DE MODIFICAR ESTE COMPONENTE CONSULTE CON SUS DESARROLLADORES.
//! ANTES DE MODIFICAR ESTE COMPONENTE CONSULTE CON SUS DESARROLLADORES.

export interface IInputTextareaProps
  extends IInputProps,
    Omit<InputTextareaProps, "name" | "defaultValue"> {}

const $InputTextarea = ({
  name,
  label,
  rules,
  disabled,
  helperText,
  defaultValue,
  disabledInput,
  fieldClassName,
  shouldUnregister,
  ...props
}: IInputTextareaProps) => {
  const { field, fieldState } = useController({
    name,
    rules,
    disabled,
    defaultValue,
    shouldUnregister,
  });

  return (
    // style={{ cursor: disabledInput ? "not-allowed" : "inherit" }}
    <Field
      name={name}
      label={label}
      helperText={helperText}
      className={fieldClassName}
      isRequired={!!rules?.required}
    >
      <InputTextarea
        id={field.name}
        {...field}
        {...props}
        disabled={disabledInput}
        invalid={fieldState.invalid}
      />
    </Field>
  );
};

export default $InputTextarea;
